import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { PostCommentModel } from "@/types/post";
import postCommentApi from "@/services/modules/postComment";
import accountApi from "@/features/admin/api/account";

const slice = createSlice({
  name: "post",
  initialState: {
    commentList: [],
  } as PostCommentState,
  reducers: {
    selectComment: (
      state,
      { payload }: { payload: PostCommentModel | undefined }
    ) => {
      return {
        ...state,
        selectedComment: payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        postCommentApi.endpoints.getPostComments.matchPending,
        accountApi.endpoints.getUserComments.matchPending
      ),
      (state) => {
        return {
          ...state,
          commentList: [],
        };
      }
    );
    builder.addMatcher(
      isAnyOf(
        postCommentApi.endpoints.getPostComments.matchFulfilled,
        accountApi.endpoints.getUserComments.matchFulfilled
      ),
      (state, { payload }) => {
        return {
          ...state,
          commentList: payload,
        };
      }
    );
    builder.addMatcher(
      postCommentApi.endpoints.deleteComment.matchFulfilled,
      (state, { payload }) => {
        return {
          ...state,
          commentList: state.commentList.filter(
            (c) => c.postCommentId != payload
          ),
        };
      }
    );
    builder.addMatcher(
      postCommentApi.endpoints.likeDislikeComment.matchFulfilled,
      (state, { payload }) => {
        let commentList = state.commentList.slice();
        const index = commentList.findIndex(
          (c) => c.postCommentId == payload[0].postCommentId
        );
        if (index > -1) {
          commentList[index] = payload[0];
        } else {
          commentList.splice(0, 0, ...payload);
        }
        return {
          ...state,
          commentList,
        };
      }
    );
    builder.addMatcher(
      postCommentApi.endpoints.addEditComment.matchFulfilled,
      (state, { payload: { comments } }) => {
        let commentList = state.commentList.slice();
        const index = commentList.findIndex(
          (c) => c.postId == comments[0].postCommentId
        );
        if (index > -1) {
          commentList[index] = comments[0];
        } else {
          commentList.splice(0, 0, ...comments);
        }
        return {
          ...state,
          commentList,
        };
      }
    );
  },
});

export const { selectComment } = slice.actions;

export default slice.reducer;

export interface PostCommentState {
  commentList: PostCommentModel[];
  selectedComment?: PostCommentModel;
}
